import React from 'react';

import {PermissionEnum} from '../../constants/permissionsEnum';
import NotFoundPage from '../ErrorHandling/NotFoundComp/NotFound';
import {checkIfHasPermissions} from '../Menu/Utils/commonFunctions';

interface PermissionWrapperProps {
  permission: PermissionEnum | Boolean;
  children: React.ReactNode;
}

const PermissionCheckerHoc: React.FC<PermissionWrapperProps> = ({
  permission,
  children
}) => {
  const hasPermission =
    typeof permission === 'boolean'
      ? permission
      : checkIfHasPermissions(permission as PermissionEnum);

  return hasPermission ? <>{children}</> : <NotFoundPage />;
};

export default PermissionCheckerHoc;
